import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Unhandled app error", error, errorInfo);
  }

  handleReload = () => {
    if (typeof window !== "undefined") {
      window.location.reload();
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "grid",
            placeItems: "center",
            padding: 24,
            background: "#0f1115",
            color: "#fff",
            fontFamily: "Inter, system-ui, -apple-system, sans-serif",
          }}
        >
          <div style={{ maxWidth: 640, textAlign: "center" }}>
            <h1 style={{ marginBottom: 12 }}>Something went wrong</h1>
            <p style={{ opacity: 0.85, lineHeight: 1.6 }}>
              The app hit an unexpected error. Reload to continue. If this keeps
              happening, capture console logs and report the last action.
            </p>
            <button
              onClick={this.handleReload}
              style={{
                marginTop: 20,
                border: 0,
                borderRadius: 10,
                padding: "10px 16px",
                background: "#6c5ce7",
                color: "#fff",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              Reload App
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
